// TODO: Migrate off of Backbone
import type ItemMetadata from 'pages/open-course/common/models/itemMetadata';

type Progress = $TSFixMe; // Progress based on pages/open-course/common/models/progress

/**
 * Methods for reading the state in graded discussion prompt's ItemProgress objects.
 *
 * The purpose of this class is to interpret the progress attributes returned in graded discussion prompts' item progress.
 * The item progress model only supports three states: "Not Started", "Started", and "Completed"; however,
 * graded discussion prompts need to track five states: "Not Started", "Overdue", "Started", "Grading", and "Completed".
 */
class DiscussionPromptState {
  declare itemMetadata: ItemMetadata;

  declare itemProgress: Progress;

  constructor(itemMetadata: ItemMetadata, itemProgress: Progress) {
    this.itemMetadata = itemMetadata;
    this.itemProgress = itemProgress;
  }

  isCompleted(): boolean {
    return this.itemProgress.isComplete();
  }

  isGrading(): boolean {
    const gradingStartTimestamp = this.itemProgress.getDefinition('gradingStartsAt');
    if (!this.isCompleted() && this.isStarted() && gradingStartTimestamp && Date.now() > +gradingStartTimestamp) {
      return true;
    }
    return false;
  }

  isStarted(): boolean {
    return this.itemProgress.isAtLeastStarted();
  }

  isOverdue(): boolean {
    const gradingStartTimestamp = this.itemProgress.getDefinition('gradingStartsAt');
    if (!this.isStarted() && gradingStartTimestamp && Date.now() > +gradingStartTimestamp) {
      return true;
    }
    return false;
  }
}

export default DiscussionPromptState;
